module.exports = __webpack_public_path__ + "img/logo_d.b1007d6c.jpg";